import mapFunction from './mapResources';

export default mapFunction('roles', {
    isFetching: false,
    items: [] 
});
